import {
  TransactionIncomeCategory,
  TransactionExpenseCategory,
  TransactionCreditCategory,
  TransactionSavingCategory,
  TransactionBankOperationCategory,
  TransactionRefundCategory,
  TransactionTaxCategory,
  TransactionCategory,
} from '@algoan/dashboard/model';
import { transactionCategoryToCashFlowNature } from '@algoan/dashboard/converters';

export enum CategoryGroup {
  INFLOW = 'INFLOW',
  EXPENSE = 'EXPENSE',
  CREDIT = 'CREDIT',
  SAVING = 'SAVING',
  BANK_OPERATION = 'BANK_OPERATION',
  REFUND = 'REFUND',
  TAX = 'TAX',
}

export interface CategoryDropdownOption {
  categoryGroup: CategoryGroup;
  category: TransactionCategory;
  incoming: boolean;
}

export const isIncoming = (category: TransactionCategory): boolean => {
  if (category in TransactionBankOperationCategory) {
    return transactionCategoryToCashFlowNature[category] === 'incomes';
  }

  return (
    transactionCategoryToCashFlowNature[category] === 'incomes' ||
    transactionCategoryToCashFlowNature[category] === 'resources'
  );
};

const buildCategoriesList = (): CategoryDropdownOption[] => {
  const categories = [];

  for (const key in TransactionIncomeCategory) {
    const incomeCategory = key as TransactionIncomeCategory;

    categories.push({
      categoryGroup: CategoryGroup.INFLOW,
      category: incomeCategory,
      incoming: isIncoming(incomeCategory),
    });
  }

  for (const key in TransactionExpenseCategory) {
    const expenseCategory = key as TransactionExpenseCategory;
    categories.push({
      categoryGroup: CategoryGroup.EXPENSE,
      category: expenseCategory,
      incoming: isIncoming(expenseCategory),
    });
  }

  for (const key in TransactionCreditCategory) {
    const creditCategory = key as TransactionCreditCategory;

    categories.push({
      categoryGroup: CategoryGroup.CREDIT,
      category: creditCategory,
      incoming: isIncoming(creditCategory),
    });
  }

  for (const key in TransactionSavingCategory) {
    const savingCategory = key as TransactionSavingCategory;

    categories.push({
      categoryGroup: CategoryGroup.SAVING,
      category: savingCategory,
      incoming: isIncoming(savingCategory),
    });
  }

  for (const key in TransactionBankOperationCategory) {
    const bankOperationCategory = key as TransactionBankOperationCategory;

    categories.push({
      categoryGroup: CategoryGroup.BANK_OPERATION,
      category: bankOperationCategory,
      incoming: isIncoming(bankOperationCategory),
    });
  }

  for (const key in TransactionRefundCategory) {
    const refundCategory = key as TransactionRefundCategory;

    categories.push({
      categoryGroup: CategoryGroup.REFUND,
      category: refundCategory,
      incoming: isIncoming(refundCategory),
    });
  }

  for (const key in TransactionTaxCategory) {
    const taxCategory = key as TransactionTaxCategory;

    categories.push({
      categoryGroup: CategoryGroup.TAX,
      category: taxCategory,
      incoming: isIncoming(taxCategory),
    });
  }

  return categories;
};

export const categoriesList = buildCategoriesList();
export const categoriesListEntry = categoriesList.filter((category) => category.incoming);
export const categoriesListOut = categoriesList.filter((category) => !category.incoming);
